import { createRoot, type Root } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';

import App from './components/App';
import { HostedPageWrapper } from './components/HostedPageWrapper';
import ErrorFallback from './components/ErrorFallback';
import { DevForm } from './components/DevForm';
import { HostedGlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { parseQueryParams, initializeWidgetData } from './core';
import { WidgetVariantProvider } from './context/WidgetVariantContext';

let devFormVisible = false;
let devFormRoot: Root | null = null;

function toggleDevForm() {
  devFormVisible = !devFormVisible;
  renderDevForm();
}

function renderDevForm() {
  if (window.location.hostname !== 'localhost') return;

  let devContainer = document.getElementById('dev-form-container');
  if (!devContainer) {
    devContainer = document.createElement('div');
    devContainer.id = 'dev-form-container';
    document.body.appendChild(devContainer);
  }

  if (!devFormRoot) {
    devFormRoot = createRoot(devContainer);
  }

  devFormRoot.render(
    <DevForm
      currentVariant="hosted"
      isVisible={devFormVisible}
      onToggle={toggleDevForm}
    />
  );
}

async function initializeHostedPage() {
  const container = document.getElementById('tomis-review-widget');
  if (!container) {
    console.error('Widget container not found');
    return;
  }

  const { reminder, ratingClicked, mode, previewConfig } = parseQueryParams();

  try {
    const initialData = await initializeWidgetData(
      reminder,
      ratingClicked,
      mode,
      previewConfig
    );

    const root = createRoot(container);
    root.render(
      <WidgetVariantProvider value="hosted">
        <ThemeProvider theme={theme}>
          <HostedGlobalStyles />
          <HostedPageWrapper
            themeColor={initialData.theme}
            businessName={initialData.business_name}
          >
            <App initialData={initialData} />
          </HostedPageWrapper>
        </ThemeProvider>
      </WidgetVariantProvider>
    );
  } catch (error) {
    console.error('Failed to initialize TOMIS Review Widget:', error);

    const root = createRoot(container);
    root.render(<ErrorFallback />);
  }

  if (window.location.hostname === 'localhost') {
    renderDevForm();
  }
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHostedPage);
  } else {
    initializeHostedPage();
  }
}
